import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Viewport = styled.div`
  opacity: ${p => p.opacity};
  transition: all ${p => p.duration}ms;
  width: 100%;
`;
